/**
 * Collection of reactions as object (key is unique id from containerAri and ari combined)
 */

/**
 * Event handler when reactions dialog selected emoji is clicked
 * @param emojiId selected emoji
 * @param analyticsEvent Optional analytics event emitted from @atlaskit/tabs component
 */

/**
 * MetaData for Reaction object
 */

/**
 * Metadata for composing a summary of emojis that will be shown in the the primary view even if the reaction count is zero
 */

/**
 * Event handler for when the user clicks on the reaction
 * @param id give id for the emoji
 * @param event selected mouse event proerties
 */

/**
 * Event handler for when the user hovers with the mouse on the reaction
 * @param emojiId id of emoji
 * @param event (Optional) custom DOM event handler callback
 */

/**
 * Event handler for when the user focused on the reaction
 * @param emojiId id of emoji
 * @param event (Optional) custom DOM event handler callback
 */

export var ReactionUpdateType = /*#__PURE__*/function (ReactionUpdateType) {
  ReactionUpdateType["added"] = "added";
  ReactionUpdateType["removed"] = "removed";
  return ReactionUpdateType;
}({});
/**
 * Event handler that is invoked when a reaction update is successful.
 *
 * @param {ReactionUpdateType} action - The action performed on the reaction.
 * @param ari - The ARI (Atlassian Resource Identifier) of the entity.
 * @param emojiId - The ID of the emoji used in the reaction.
 */

/**
 * Condition of the reaction when gets loaded from the store
 */
export var ReactionStatus = /*#__PURE__*/function (ReactionStatus) {
  ReactionStatus["ready"] = "READY";
  ReactionStatus["loading"] = "LOADING";
  ReactionStatus["error"] = "ERROR";
  ReactionStatus["notLoaded"] = "NOT_LOADED";
  ReactionStatus["disabled"] = "DISABLED";
  return ReactionStatus;
}({});

/**
 * state in which the reaction is at
 */

/**
 * Source where the emoji selected from ("quickSelector" -> default list, "emojiPicker" -> custom emoji list)
 */